export default "__VITE_ASSET__DT9ZS9v9__"